var React = require('react');

function LayersInline (props) {
    return React.createElement("path",props);
}

LayersInline.defaultProps = {"d":"M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z"};

module.exports = LayersInline;

LayersInline.default = LayersInline;
